import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import {
  isValid,
  REQUIRED,
  validate,
} from "../../utils/Validation";
import SelectField from "../../components/SelectField";
import { getAllDrinks } from "../../api/Drink";
import TextAreaField from "../../components/TextAreaField";


export default function EditCategories({ selected, onClose, onSave }) {
  const [category, setCategory] = useState({
    nameBr: "",
    order: "0",
    descriptionBr: "",
    drink: null,
    attributes: [],
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [drinks, setDrinks] = useState([]);

  useEffect(() => {
    loadDrinks();
    if(!!selected){
      setCategory({ ...selected, ...{ order: `${selected.order}` } }); // This is necessary to prevent zero value from not being displayed
    } else{
      clear();
    }
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
  }, [selected]);

  const loadDrinks = async () => {
    const res = await getAllDrinks("nameBr", "ASC");
    setDrinks(res.map(d => ({ label: d.nameBr, value: d })));
  }

  const clear = () => {
    setCategory({
      nameBr: "",
      order: "0",
      descriptionBr: "",
      drink: null,
      attributes: [],
    });
    setErrors({});
    setSubmitting(false);
  };

  const save = async () => {
    setSubmitting(true);
    const rules = {
      nameBr: REQUIRED,
      order: REQUIRED,
      descriptionBr: REQUIRED,
      drink: REQUIRED,
    };
    const errors = await validate(rules, category);
    if (isValid(errors)) {
      onSave(category);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={category?.id ? "Editar Categoria" : "Novo Categoria"}
      Action={<Button disabled={submitting} submitting={submitting} onClick={() => save()}>Cadastrar</Button>}
    >
      <TextField
        className="mb-5"
        placeholder="Insira um nome"
        value={category}
        field="nameBr"
        update={setCategory}
        errors={errors}
      />
      <TextField
        className="mb-5"
        placeholder="Insira a posição"
        value={category}
        field="order"
        update={(data) => {
          data.order = data.order.replace(new RegExp("[^0-9]", "g"), "");
          setCategory(data);
        }}
        errors={errors}
      />
      <TextAreaField
        className="mb-5"
        placeholder="Insira uma descrição"
        value={category}
        field="descriptionBr"
        update={setCategory}
        errors={errors}
        rows={5}
      />
      { !!category?.id ? (
        <TextField
          label="Bebida"
          className="mb-5"
          value={category?.drink?.nameBr ?? ""}
          disabled={true}
        />
      ) : (
        <SelectField
          className="mt-12 mb-12"
          label="Bebida"
          errors={errors}
          field="drink"
          options={drinks}
          update={setCategory}
          value={category}
        />
      )}
      <div className="h-20" />
    </Modal>
  );
}
